<template>
  <div class="fh-area fh-container">
    <div id="menu">
      <b-container>
        <b-nav>
<!--
          <b-nav-item to="/dashboard" exact exact-active-class="active"
            >{{ $t('dashboard.menu.summary') }}</b-nav-item
          >
-->
          <b-nav-item to="/dashboard/rdbm" active-class="active"
            >RDBM</b-nav-item
          >
<!--
          <b-nav-item to="/dashboard/billing" active-class="active"
            >{{ $t('dashboard.menu.billing') }}</b-nav-item
          >
-->
        </b-nav>
      </b-container>
    </div>

    <b-container id="content" class="fh-area fh-container" fluid>
      <!-- Cообщения -->
      <message-view></message-view>
      <!-- Компонент -->
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
import MessageView from "@/components/MessageView";
export default {
  name: "UserDashboard",
  components: {
    MessageView,
  },
  mounted() {
    /*
    let host = window.location.host;  // hostname - без номера порта!
    let ssoScript = document.createElement('script')
    ssoScript.setAttribute('src', 'https://' + host + '/sso-signin.js')
    document.head.appendChild(ssoScript)
     */
  },
};
</script>